import { transactionsSelectors } from 'app-components/flux/transactions';
import type { TransactionProps } from 'app-components/flux/transactions/transactionsTypes';
import { getLength } from 'app-components/utils/core/immutableHelpers';
import { createAppSelector } from 'app-components/utils/core/reselect';
import { type RootState } from 'store';

export const getTxnTransferHasAllocations = createAppSelector(
  [
    (state: RootState, props: { transferId?: string | null }) =>
      props.transferId ? transactionsSelectors.getTransactionById(state, props.transferId) : null,
  ],
  (transferTxn) => {
    return getLength(transferTxn?.allocations) > 0;
  },
);

export const isArAssociatedPaymentTxn = (
  txn: Pick<TransactionProps, 'coa' | 'split'> | null | undefined,
  arAccountIds: { includes: (id: string | null | undefined) => boolean },
): boolean => {
  if (arAccountIds?.includes(txn?.coa?.id)) {
    return true;
  }
  return !!txn?.split?.items?.some((item) => arAccountIds?.includes(item?.coa?.id));
};
